export default __webpack_public_path__ + "static/media/peachBranch.e04403bf.png";